var _circle, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconAlertFilled = function SvgIconAlertFilled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 6.5,
    r: 6.5,
    fill: "#C00020"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.41794 3.21638L6.62493 7.614L6.83156 3.21638C6.83283 3.18826 6.82836 3.16018 6.81842 3.13386C6.80848 3.10753 6.79327 3.08351 6.77373 3.06326C6.75419 3.043 6.73072 3.02695 6.70476 3.01608C6.67881 3.0052 6.6509 2.99974 6.62276 3.00001C6.59496 3.00027 6.56749 3.00613 6.542 3.01725C6.51651 3.02836 6.49351 3.0445 6.4744 3.06469C6.45528 3.08488 6.44043 3.10872 6.43073 3.13479C6.42103 3.16085 6.41668 3.1886 6.41794 3.21638Z",
    fill: "white",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62503 10.4957C6.48238 10.4957 6.34294 10.4534 6.22434 10.3741C6.10574 10.2949 6.0133 10.1822 5.95871 10.0504C5.90412 9.91865 5.88984 9.77364 5.91767 9.63374C5.9455 9.49384 6.01418 9.36533 6.11505 9.26446C6.21591 9.1636 6.34442 9.09491 6.48432 9.06708C6.62423 9.03925 6.76924 9.05354 6.90103 9.10812C7.03281 9.16271 7.14545 9.25515 7.2247 9.37375C7.30395 9.49236 7.34625 9.6318 7.34625 9.77444C7.34625 9.96572 7.27026 10.1492 7.13501 10.2844C6.99975 10.4197 6.81631 10.4957 6.62503 10.4957Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconAlertFilled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-alert-filled.3921de19.svg";
export { ForwardRef as ReactComponent };